export enum PersistenceLevelEnum {
    None = 'None',
    Everytime = 'Everytime',
    Onetime = 'Onetime'
}
